export default __webpack_public_path__ + "static/media/img_10.83ac4cd9.jpg";